const LessThenOrEqualsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M18.5 2.27 5 10.14 18.5 18l1-1.73-10.53-6.13L19.5 4l-1-1.73M5 20v2h15v-2H5Z" />
  </svg>
)
export default LessThenOrEqualsIcon
